import React, { useEffect, useState } from "react";
import api from '../api/axiosInstance';
import { Container, Card, Spinner, Alert, Button } from "react-bootstrap"; // Button zaten import edilmişti
import AppNavbar from "../components/AppNavbar";
import { useNavigate } from "react-router-dom"; // 1. Değişiklik: useNavigate import edildi

const ProfilePage = () => {
  const [user, setUser] = useState(null);
  const [message, setMessage] = useState(null);
  const [loading, setLoading] = useState(true);
  
  // 2. Değişiklik: Yönlendirme için hook tanımlandı
  const navigate = useNavigate(); 

  useEffect(() => {
    const token = localStorage.getItem("token");

    api
      .get("/auth/me", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        const u = res.data;
        setUser(u);
      })
      .catch(() => setMessage({ type: "danger", text: "Kullanıcı bilgileri alınamadı." }))
      .finally(() => setLoading(false));
  }, []);

  if (loading)
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "100vh" }}>
        <Spinner animation="border" />
      </div>
    );

  return (
    <>
      <AppNavbar />

      <Container className="d-flex justify-content-center" style={{ marginTop: "120px", marginBottom: "50px" }}>
        <Card className="p-4 shadow-lg" style={{ width: "100%", maxWidth: "550px", borderRadius: "15px" }}>
          <h3 className="text-center mb-4" style={{ color: "#2D8A7A" }}>
            Bilgilerimi Görüntüle
          </h3>

          {message && <Alert variant={message.type}>{message.text}</Alert>}

          {user && (
            <div>
              {/* Kullanıcı Bilgileri */}
              <div className="mb-3">
                <label className="fw-bold text-secondary">Ad Soyad</label>
                <p className="border p-2 rounded bg-light">{user.name}</p>
              </div>

              <div className="mb-3">
                <label className="fw-bold text-secondary">E-posta</label>
                <p className="border p-2 rounded bg-light">{user.email}</p>
              </div>

              <div className="mb-3">
                <label className="fw-bold text-secondary">Telefon</label>
                <p className="border p-2 rounded bg-light">{user.phone}</p>
              </div>

              <div className="mb-3">
                <label className="fw-bold text-secondary">Meslek</label>
                <p className="border p-2 rounded bg-light">{user.category}</p>
              </div>

              {/* Hesap Durumu */}
              <div className="mb-3">
                <label className="fw-bold text-secondary">Hesap Durumu</label>
                <p
                  className="border p-2 rounded"
                  style={{
                    backgroundColor: user.isApproved ? "#d4f7df" : "#ffe9e9",
                    color: user.isApproved ? "#0a7a28" : "#b30000",
                    fontWeight: 600,
                  }}
                >
                  {user.isApproved ? "Onaylı Kullanıcı" : "Ödeme Bekleniyor"}
                </p>
              </div>

              {/* 3. Değişiklik: Ödeme Butonu Eklendi */}
              <div className="d-grid gap-2 mt-4">
                <Button 
                  variant="primary" 
                  size="lg"
                  style={{ backgroundColor: "#2D8A7A", borderColor: "#2D8A7A" }}
                  onClick={() => navigate("/odeme")}
                >
                  Ödeme Sayfasına Git
                </Button>
              </div>

            </div>
          )}
        </Card>
      </Container>
    </>
  );
};

export default ProfilePage;